export default "__VITE_ASSET__BTknZdaJ__"